import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  AlertColor,
  Alert,
  Card,
} from '@mui/material';
import { useErroLogin, useSessionActions, useSessionUser } from 'shared/store/session';
import { useTranslation } from 'react-i18next';


export const LoginToken: React.FC = () => {
  const { token } = useParams<'token'>();

  const erroLogin = useErroLogin();
  const user = useSessionUser();
  const userActions = useSessionActions();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState<null | { text: string; type: AlertColor }>(null);

  const { t } = useTranslation();

  React.useEffect(() => {
    if (token) {
      setIsLoading(true);
      userActions.loginToken(token).then()
        .catch(() => {
          setAlert({
            text: t('messages.login.failed'),
            type: 'error',
          });
        })
        .finally(() => {
          setIsLoading(false);
        });

    }
  }, []);

  React.useEffect(() => {
    if (erroLogin && !user) {
      setAlert({
        text: t('messages.login.failed'),
        type: 'error',
      });
    }
  }, [erroLogin]);

  React.useEffect(() => {
    if (user && !isLoading) {
      navigate('/');
    }
  }, [user, isLoading]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        width: '450px',
        margin: '0 auto',
      }}
    >
      <Card sx={{ marginTop: '80px' }}>

        {alert ? (
          <Alert severity={alert.type} onClose={() => setAlert(null)}>
            {alert.text}
          </Alert>
        ) : 'OK'}
      </Card>
    </Box>
  );
};
